import { Box, Grid, MenuItem, TextField } from '@mui/material';
import { BusFormSection, busFieldSize } from './BusFormSection';
import BusDocumentUpload from './BusDocumentUpload';
import BusPhotoUpload from './BusPhotoUpload';
import React, { useCallback, useEffect, useState } from "react"
import { post } from "../../services/api"
import ENDPOINTS from "../../utils/constants/endpoints"



export const BusDetailComponent = React.memo(({ form, handleChange, handleFileChange, uploading, errors = {} }) => {
    const [vehicleTypes, setVehicleTypes] = useState([]);
    useEffect(() => {

        fetchVehicleTypes();

    }, []);
    const fetchVehicleTypes = useCallback(async () => {

        const payload = {
            token: localStorage.getItem("token") || "",
        };

        try {

            const response = await post(
                ENDPOINTS.MASTER.VEHICLE_TYPE_LIST,
                payload
            );

            console.log("Vehicle Types >>>", response);

            if (response?.data) {
                setVehicleTypes(response.data);
            }

        } catch (error) {
            console.error("Vehicle type API error:", error);
        }

    }, []);

    const field = (name, label, required = false, type = 'text') => <TextField fullWidth required={required} type={type} label={label} name={name} value={form[name] || ''} onChange={handleChange} error={Boolean(errors[name])} helperText={errors[name]} InputLabelProps={type === 'date' ? { shrink: true } : undefined} />;
    return <>
      <BusFormSection title="Vehicle Information / वाहन विवरण">
        <Grid container spacing={1.5}>
          {['bus_number','owner_name','capacity','model','purchase_year'].map((name,index) => <Grid size={busFieldSize} key={name}>{field(name, ['Bus Number','Owner Name','Capacity','Model','Purchase Year'][index], index < 4, name === 'capacity' ? 'number' : 'text')}</Grid>)}
          <Grid size={busFieldSize}><TextField select fullWidth label="Vehicle Type" name="vehicle_type_id" value={form.vehicle_type_id || ''} onChange={handleChange}><MenuItem value="">Select Vehicle Type</MenuItem>{vehicleTypes.map(type => <MenuItem key={type.vehicle_type_id} value={type.vehicle_type_id}>{type.vehicle_type}</MenuItem>)}</TextField></Grid>
        </Grid>
      </BusFormSection>
      <BusFormSection title="Bus Photographs / बस की तस्वीरें">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2,minmax(0,1fr))', sm: 'repeat(4,minmax(0,1fr))' }, gap: 1.5, maxWidth: 720 }}>
          {[1,2,3,4].map(index => <BusPhotoUpload key={index} name={`upload_photo_${index}`} index={index} value={form[`upload_photo_${index}`]} uploading={uploading[`upload_photo_${index}`]} onChange={handleFileChange} />)}
        </Box>
      </BusFormSection>
      <BusFormSection title="Registration Certificate / पंजीकरण प्रमाणपत्र">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0,1fr)', md: 'minmax(0,1fr) minmax(210px,260px)' }, gap: 1.5, alignItems: 'start' }}><Grid container spacing={1.5}>
          <Grid size={{ xs: 12, sm: 6 }}>{field('rc_issue_date','RC Issued Date',true,'date')}</Grid>
          <Grid size={{ xs: 12, sm: 6 }}>{field('rc_valid_upto','RC Valid Upto',false,'date')}</Grid>
          </Grid><Box sx={{ minWidth: 0 }}><BusDocumentUpload name="upload_rc" label="RC Document" value={form.upload_rc} required onChange={handleFileChange} uploading={uploading.upload_rc} /></Box></Box>
      </BusFormSection>
    </>;
});
